import { coco, isChartArtifactPayload } from '@cotera/api';
import type { CustomToolRenderer } from '@cotera/client/v0/chat/tool-renderers';
import { ChartInlinePreview } from '@cotera/client/v0/components/charts';
import { useArtifactPanel } from '@cotera/client/v0/chat/artifact-panel-context';
import { ToolPart } from '@cotera/sdk/core';

const { COCO_RENDER_CHART_TOOL_KEY } = coco;

export const ChartToolRenderer: CustomToolRenderer = ({ part }) => {
  const artifactPanel = useArtifactPanel();
  const artifact = part.getArtifact();

  if (artifact === null || !isChartArtifactPayload(artifact.data)) {
    return null;
  }

  const artifactId = artifact.artifactId ?? part.toolCallId;

  return (
    <ChartInlinePreview
      payload={artifact.data}
      onOpen={
        artifactPanel !== null
          ? () => {
              artifactPanel.focusArtifact(artifactId);
            }
          : undefined
      }
    />
  );
};

export function isRenderChartToolPart(part: ToolPart): boolean {
  return part.toolKey().toString() === COCO_RENDER_CHART_TOOL_KEY;
}
